import React from 'react';
import ServicePageSplit from '../ServicePageSplit/ServicePageSplit';
import sectionImage from '../../assets/services/landscape-design.jpg';

const tags = [
  'Flagstone installation',
  'Paver installation',
  'Xeriscape design',
  'Retaining walls',
  'Drip irrigation',
  'Boulder installation',
  'Plant selection',
  'Native plants',
  'Sod installation',
  'Artificial turf',
  'Fence installation',
  'Concrete work',
];

const paragraphs = [
  "Colorado's climate is unlike anywhere else, and your yard needs to be designed with that in mind. We account for altitude, snow load, freeze-thaw cycles, and dry summers so your landscape looks great in year one and still thrives years later.",
  "With over 15 years of experience across the Roaring Fork Valley, we know what works here and what doesn't. Every material, plant, and layout decision is made with your property, your goals, and your long-term maintenance in mind.",
];

const ServiceLandscapeCustom = () => (
  <ServicePageSplit
    variant="cream"
    tag="WHAT WE DO"
    heading="Every project, completely custom."
    paragraphs={paragraphs}
    image={sectionImage}
    imageAlt="Landscape design and installation by Fresh Start"
    tags={tags}
  />
);

export default ServiceLandscapeCustom;
